import type { ArrowDirection } from '../../components/atomic/buttons/arrows/Arrows';
import { useAppStore } from '../../../store/appStore';
import { getDeliveryPopupPlacement } from '../delivery_popups/deliveryPopupPositions';
import type { MapCamera } from '../MapScreenModelScreen';
import { DeliveryHintIcon } from './DeliveryHintIcon';
import {
  ARROW_TO_HINT_DIRECTION,
  countOffscreenDeliveryHints,
  placementToOffscreenRect,
} from './offscreenDeliveryHints';

const ALL_ARROW_DIRECTIONS: readonly ArrowDirection[] = [
  'up',
  'down',
  'left',
  'right',
];

export type MapDeliveryHintsProps = {
  camera: MapCamera;
  /** Which arrow-side badges to show; defaults to all four. */
  directions?: readonly ArrowDirection[];
  viewportWidth: number;
  viewportHeight: number;
};

/** Red count badges next to arrows for active deliveries outside the viewport. */
export function MapDeliveryHints({
  camera,
  directions = ALL_ARROW_DIRECTIONS,
  viewportWidth,
  viewportHeight,
}: MapDeliveryHintsProps) {
  const deliveryPool = useAppStore((s) => s.playerEconomy.deliveryPool);

  const rects = deliveryPool
    .filter((entry) => entry.status === 'active' && entry.fromHistoryReplay !== true)
    .map((entry) => getDeliveryPopupPlacement(entry.giantId))
    .filter((placement): placement is NonNullable<typeof placement> => placement != null)
    .map(placementToOffscreenRect);

  const counts = countOffscreenDeliveryHints(
    rects,
    camera,
    camera.scale,
    viewportWidth,
    viewportHeight,
  );

  return (
    <>
      {directions.map((direction) => {
        const count = counts[direction];
        if (count <= 0) {
          return null;
        }

        return (
          <DeliveryHintIcon
            key={direction}
            direction={ARROW_TO_HINT_DIRECTION[direction]}
            value={count}
          />
        );
      })}
    </>
  );
}
